import { Application } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

window.Turbo = Turbo

export { application }

